import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://edecbdb6342aef6e9e00142c9cf27d43@o4506783322669056.ingest.sentry.io/4506783324700672",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});
import "@astrojs/vercel/speed-insights"